import { onScreen } from 'Lib/on-screen/on-screen';
import { loadSrcOrBg } from 'Lib/load-src-or-bg/load-src-or-bg';
import { eventSender } from 'Lib/event-sender/event-sender';

const $whatReadItem = $('.what-read__item');

function setBgImg() {
    onScreen($('.what-read__img-box'), loadSrcOrBg);
}

function sendEventGA4($el, event) {
    eventSender.customDL({
        event: 'eksmo',
        eventAction: event,
        eventCategory: $('title').text().trim(),
        eventLabel: `Что почитать. Выбор редакции - ${$el.find('.what-read__title').text()}`,
    });
}

function shuffleWhatRead(elsWhatRead) {
    // Сначала сортируем книги по полю sortOrder
    elsWhatRead.sort((a, b) => a.getAttribute('data-sort') - b.getAttribute('data-sort'));

    // Группируем книги по sortOrder
    const groupselWhatRead = {};

    elsWhatRead.forEach((elWhatRead) => {
        const sortOrder = elWhatRead.getAttribute('data-sort');

        if (!groupselWhatRead[sortOrder]) {
            groupselWhatRead[sortOrder] = [];
        }

        groupselWhatRead[sortOrder].push(elWhatRead);
    });

    // Перемешиваем книги внутри каждой группы
    Object.keys(groupselWhatRead).forEach((sortOrder) => {
        groupselWhatRead[sortOrder] = shuffleArray(groupselWhatRead[sortOrder]);
    });

    // Объединяем группы обратно в массив
    const result = [];

    Object.keys(groupselWhatRead).sort().forEach((sortOrder) => {
        result.push(...groupselWhatRead[sortOrder]);
    });

    return result;
}

// Функция для перемешивания массива
function shuffleArray(array) {
    const newArray = [...array];

    for (let i = newArray.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));

        [newArray[i], newArray[j]] = [newArray[j], newArray[i]];
    }

    return newArray;
}

const elWhatRead = document.querySelector('.what-read__box');
const elsWhatRead = Array.from(elWhatRead.children);
const shuffledWhatRead = shuffleWhatRead(elsWhatRead);

elWhatRead.innerHTML = '';

shuffledWhatRead.forEach((item, i) => {
    if (i !== 0 && i < 4) {
        item.querySelector('.what-read__img-box').classList.add('what-read__img-box_no-bg');
    }

    elWhatRead.appendChild(item);
});

document.querySelector('.what-read').classList.remove('what-read_inactive');

onScreen($whatReadItem, ($el) => {
    sendEventGA4($el, 'view');
}, 0, 0, 0.8);

$whatReadItem.on('click', function () {
    sendEventGA4($(this), 'click');
});

setBgImg();
$('body').on('eksmoResizeWidth', setBgImg);